import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { debounce } from 'throttle-debounce';

import { TThunkDispatch } from '../../types/redux/thunk';
import { addFavorite, deleteFavorite } from '../../actions/favorite';
import { FAVORITE_DEBOUNCE_DELAY } from '../../constants/delays';
import { useOfferContext } from '../../utils/offerContext';

export const FavoriteContainer: React.FC = () => {
  const {
    id,
    isFavorite,
    analytics: { gaLabel },
  } = useOfferContext();
  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = React.useCallback(
    debounce(FAVORITE_DEBOUNCE_DELAY, () => {
      if (isFavorite) {
        dispatch(deleteFavorite({ offerId: id, label: gaLabel }));
      } else {
        dispatch(addFavorite({ offerId: id, label: gaLabel }));
      }
    }),
    [dispatch, id, isFavorite, gaLabel],
  );

  if (isFavorite == null) {
    return null;
  }

  return (
    <Button
      onClick={handleClick}
      theme="fill_secondary"
      size="XS"
      beforeIcon={
        isFavorite ? (
          <IconToggleHeartOn16 color="icon-negative-default" />
        ) : (
          <IconToggleHeartOff16 color="icon-negative-default" />
        )
      }
    >
      {isFavorite ? 'В избранном' : 'В избранное'}
    </Button>
  );
};
